


import {AuthRequestVM} from './AuthRequestVM';
export class SignInRequestVM extends AuthRequestVM {
    
    password?: string;
    
}
